import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, HostBinding, Input, NgModule } from '@angular/core';

class SeFeIndicatorDotComponent {
    constructor() {
        this.baseClass = true;
        this.value = 0;
        this.notify = false;
    }
    get indicatorValue() {
        const str = this.value.toString();
        return str === '0' ? '' : str;
    }
}
SeFeIndicatorDotComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeIndicatorDotComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeIndicatorDotComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeIndicatorDotComponent, selector: "se-fe-indicator-dot", inputs: { value: ["seFeDataValue", "value"], notify: ["seFeDataNotify", "notify"] }, host: { properties: { "class.se-fe-indicator-dot": "this.baseClass", "class.indicator-dot--fill-notify": "this.notify" } }, ngImport: i0, template: "<div class=\"indicator-dot--text\">\n  {{ indicatorValue }}\n</div>\n", styles: [":host{border-radius:999in;display:inline-flex;white-space:nowrap;align-items:center;outline:1px solid var(--se-bg);background:var(--se-info);line-height:1;min-width:14px;min-height:14px;justify-content:center;vertical-align:middle;margin:1px}:host.indicator-dot--fill-notify{background:var(--se-notify)}.indicator-dot--text{color:var(--se-color-content);display:block;font:var(--se-bold) calc(var(--se-rem, 1rem) * .75)/1 var(--se-font);margin:0 2px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeIndicatorDotComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-indicator-dot',
                    templateUrl: './se-fe-indicator-dot.component.html',
                    styleUrls: ['./se-fe-indicator-dot.component.scss'],
                }]
        }], propDecorators: { baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-indicator-dot']
            }], value: [{
                type: Input,
                args: ['seFeDataValue']
            }], notify: [{
                type: Input,
                args: ['seFeDataNotify']
            }, {
                type: HostBinding,
                args: ['class.indicator-dot--fill-notify']
            }] } });

class SeFeIndicatorDotModule {
}
SeFeIndicatorDotModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeIndicatorDotModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeIndicatorDotModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeIndicatorDotModule, declarations: [SeFeIndicatorDotComponent], imports: [CommonModule], exports: [SeFeIndicatorDotComponent] });
SeFeIndicatorDotModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeIndicatorDotModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeIndicatorDotModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeIndicatorDotComponent],
                    imports: [CommonModule],
                    exports: [SeFeIndicatorDotComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeIndicatorDotComponent, SeFeIndicatorDotModule };
